<template>
  <div>
  <v-toolbar>
    <v-toolbar-title>
      {{$t('Register.Overview.Title')}}
    </v-toolbar-title>
  </v-toolbar>
  <v-container>
    <v-row>
      <v-col cols="6">
      <v-hover>
        <div slot-scope="{ hover }" :class="`subscribe-button ma-2 pa-2 elevation-${hover ? 12 : 2}`" @click="applyPopup()">
          <div class="headline">{{$t('Register.Overview.Apply.Header')}}</div>
          <br>
          <div>{{$t('Register.Overview.Apply.Values[0]')}}</div>
          <v-icon class="ma-2">domain</v-icon>
          <div>{{$t('Register.Overview.Apply.Values[1]')}}</div>
        </div>
      </v-hover>
    </v-col>
    <v-col cols="6">
      <v-hover>
        <div slot-scope="{ hover }" :class="`subscribe-button ma-2 pa-2 elevation-${hover ? 12 : 2}`" @click="subscribePopup()">
          <div class="headline">{{$t('Register.Subscribe.Header')}}</div>
          <br>
          <div>{{$t('Register.Overview.Subscribe.Values[0]')}}</div>
          <v-icon class="ma-2">share</v-icon>
          <div>{{$t('Register.Overview.Subscribe.Values[1]')}}</div>
        </div>
      </v-hover>
    </v-col>
    </v-row>
  </v-container>
</div>

</template>

<script>
export default {
  methods: {
    applyPopup() {
      this.$router.push({
        name: 'Apply'
      })
    },
    subscribePopup() {
      this.$router.push({
        name: 'Subscribe'
      })
    }
  }

}
</script>

<style lang="css">
  .subscribe-button {
    text-align: center;
    font-weight: bold;
    cursor: pointer;
  }
</style>
